// extracted by mini-css-extract-plugin
export var anchor = "ContentPage-module--anchor--Z0ITk";
export var secondaryNav = "ContentPage-module--secondaryNav--T4fW0";
export var section = "ContentPage-module--section--uc+mz";
export var sectionImage = "ContentPage-module--sectionImage--CpgVY";